import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header border-bottom-0" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "form-floating mb-3" }
const _hoisted_6 = { class: "form-floating mb-3" }
const _hoisted_7 = { class: "form-check text-start mb-3" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_9 = { class: "text-end mt-3" }

import Modal from 'bootstrap/js/dist/modal';
import { closeDialog } from '../lib/promiseDialog';
import { ref, onMounted, computed } from 'vue';
import { shopSdk } from '../graphql/shopClient';
import { emailValidateRegex } from '../lib/emailRegex';
import { useAccountStore } from '../account/accountStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'loginDialog',
  setup(__props, { expose: __expose }) {


const modalEl = ref<HTMLElement | null>(null);

const $account = useAccountStore();

const validChecked = ref(false);

const validPassword = computed(() => {
  return passwordField.value.length >= 8;
})
const validEmail = computed(() => {
  return emailValidateRegex.test(emailField.value.trim());
});

let bsModal: Modal | null = null;

const emailField = ref('');
const passwordField = ref('');
const rememberMe = ref(false);

const errorMsg = ref('');

function routeAndClose(route: string) {
  window.location.href = route;
  closeModal(false);
}

function closeModal(result: boolean) {
  bsModal?.hide();
  closeDialog(result);
}
onMounted(() => {
  if (modalEl.value) {
    bsModal = new Modal(modalEl.value);
    bsModal.show();
  }
});

function resetValidations() {
  errorMsg.value = '';
}

async function tryLogin() {
  validChecked.value = true;
  
  if (!validEmail.value || !validPassword.value) {
    return;
  }
  
  try {
    const result = await $account.tryLogin(emailField.value.trim(), passwordField.value, rememberMe.value);

    if (typeof result === 'boolean') {
      closeModal(result);
    } else {
      switch(result.type) {
        case 'InvalidCredentialsError':
          errorMsg.value = 'Invalid email or password';
          break;
        case 'NotVerifiedError':
          errorMsg.value = 'Your account has not been verified. Please check your email for a verification link.';
          break;
        default:
          errorMsg.value = `Unknown error occurred: ${result.type}: ${result.message}`;
          break;
      }
    }
  } catch (e: any) {
    errorMsg.value = `Unknown error occurred: ${e?.message || e}`
    console.error(e);
  }
}

function returnValue() {
  return true;
}

__expose({
  returnValue,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false",
    tabindex: "-1",
    "aria-labelledby": "staticBackdropLabel",
    "aria-hidden": "true",
    ref_key: "modalEl",
    ref: modalEl
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "modal-title position-absolute translate-middle-x start-50" }, " Sign in ", -1 /* HOISTED */)),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(closeDialog) && _unref(closeDialog)(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["form-control", { 'is-invalid': validChecked.value && !validEmail.value }]),
                id: "floatingInput",
                placeholder: "name@example.com",
                autocomplete: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailField).value = $event)),
                onChange: resetValidations
              }, null, 34 /* CLASS, NEED_HYDRATION */), [
                [
                  _vModelText,
                  emailField.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "floatingInput" }, "Email address", -1 /* HOISTED */)),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "invalid-feedback" }, " You must enter a valid email address. ", -1 /* HOISTED */))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: _normalizeClass(["form-control", { 'is-invalid': validChecked.value && !validPassword.value }]),
                id: "floatingPassword",
                placeholder: "Password",
                autocomplete: "current-password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordField).value = $event)),
                onChange: resetValidations
              }, null, 34 /* CLASS, NEED_HYDRATION */), [
                [
                  _vModelText,
                  passwordField.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("label", { for: "floatingPassword" }, "Password", -1 /* HOISTED */)),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "invalid-feedback" }, " Your password is invalid. ", -1 /* HOISTED */))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rememberMe).value = $event)),
                type: "checkbox",
                value: true,
                id: "rememberMe"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, rememberMe.value]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "form-check-label",
                for: "rememberMe"
              }, " Remember me ", -1 /* HOISTED */))
            ]),
            (errorMsg.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(errorMsg.value), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: "btn btn-primary w-100 py-2",
              onClick: _withModifiers(tryLogin, ["prevent"])
            }, " Sign in "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                class: "btn btn-link btn-sm p-0 me-2",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (routeAndClose('/account/request-reset')), ["prevent"]))
              }, " Forgot password? "),
              _cache[12] || (_cache[12] = _createTextVNode(" | ")),
              _createElementVNode("a", {
                class: "btn btn-link btn-sm p-0 ms-2",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (routeAndClose('/account/register')), ["prevent"]))
              }, " Create account ")
            ])
          ]),
          _createCommentVNode(" Notice Alert "),
          _cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "alert alert-info my-4",
            role: "alert"
          }, [
            _createTextVNode(" As of October 24, 2024, the SignalStuff website has been updated. Accounts from the old system were not transferred. To access your previous order history, please visit "),
            _createElementVNode("a", {
              href: "https://old.signalstuff.com/my-account/",
              class: "alert-link",
              target: "_blank"
            }, " old.signalstuff.com "),
            _createTextVNode(". ")
          ], -1 /* HOISTED */))
        ])
      ])
    ])
  ], 512 /* NEED_PATCH */))
}
}

})